export const AllSetting = {
  line_scheduling_area_timeline_step: 30,
  line_schedule_start_time: '00:00',
  line_schedule_duration: 47
}
